import { Button, Col, Row, Spinner } from "react-bootstrap";
import styles from '../../../../styles/incidents.module.css';
import IncidentSidePanel from "../incidents/incidentsidepanel";
import IncidentFollowupResonses from "./incidentfollowupresponses";
import { useForm } from "react-hook-form";
import { useIncidentFollowupResponseUpsert } from "../../../../new/query";
import useMessageStore from "../../../../stores/message-store";

const IncidentResponseToFollowupNew = ({values = null,definitions,incidentid,medicaidid,hashkey,staffAssignments}) => {
    const initialValues = {
        responses: [],
        departmentalManagementIncidentAnalysis: '',
        areasToCheck: []
    }

    const _getFormVals = (data,staffAssignments) => {
        const assignments = staffAssignments.areasToCheck.map((item) => {
            const selText = definitions.areastocheck.find((val) => val.id === item.areaToCheck).name;
            const rVal = {
                ...item,
                areaToCheckText: selText,
            }

            return rVal;
        }).sort((a,b) => a.areaToCheckText.localeCompare(b.areaToCheckText));

        return {
            ...data,
            areasToCheck: assignments
        }
    }
    
    const {control,handleSubmit,watch,register,reset,formState: {isDirty}} = useForm({defaultValues: values === null ? _getFormVals(initialValues,staffAssignments) : _getFormVals(values,staffAssignments)});
  
    const addToast = useMessageStore(state => state.addToast);


      const submittedCallback = (data) => {
        if(values === null){
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
        const {responseToFollowup,followupStaff} = data;

        const resetObj = _getFormVals(responseToFollowup,followupStaff);

        reset(resetObj);

        addToast(
            {
                id: Math.random(),
                body: "The Response was succesfully saved!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
    }

    const errorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An Error occured when submitting the Response.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    const mutation = useIncidentFollowupResponseUpsert(incidentid,medicaidid,submittedCallback,errorCallback);

    const submitFn = (data) => {
        const sendObj = {
            ...data,
            id: incidentid
        }
        mutation.mutate(sendObj);
    };

    return(
        <form onSubmit={handleSubmit(submitFn)}>
            <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                <Row>
                    <Col xs={12} md={3}>
                        <div className={styles.stickyColumn}>
                            <IncidentSidePanel data={staffAssignments} defintions={definitions}/>
                        </div>
                    </Col>
                    <Col xs={12} md={9}>
                        <Row>
                            <Col xs={12}>
                                <IncidentFollowupResonses control={control} definitions={definitions}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <label className="mt-4" htmlFor="department">Departmental management incident analysis review and cause</label>
                                <textarea id="department"  rows={5} style={{width: '100%'}} {...register('departmentalManagementIncidentAnalysis')}/>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={12}>
                                    <h5 className="text-center">Specific Areas To Check</h5>
                                 {
                                        watch('areasToCheck').map((item,index) => (
                                            <Col xs={12} key={item.id}>
                                                <div style={{border: '1px solid black',padding: '4px'}} className="mb-4">
                                                <Row>
                                                    <Col xs={12}>
                                                        <h5 className="mb-0">{item.areaToCheckText}</h5>
                                                        <p className="mb-0">{item.comments}</p>
                                                    </Col>
                                                    <Col xs={12} md={6} lg={3}>
                                                        <fieldset>
                                                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Substantiated</legend>
                                                            {
                                                                definitions.truefalsena.map(tfna => (
                                                                    <div key={tfna.id}>
                                                                    <label key={tfna.id}>
                                                                        <input type="radio" {...register(`areasToCheck[${index}].substantiated`)} value={tfna.id}/>
                                                                        {tfna.name}
                                                                    </label>
                                                                    </div>
                                                                ))
                                                            }
                                                        </fieldset>
                                                    </Col>
                                                    <Col xs={12} md={6} lg={3}>
                                                        <fieldset>
                                                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Unfounded</legend>
                                                            {
                                                                definitions.truefalsena.map(tfna => (
                                                                    <div key={tfna.id}>
                                                                    <label key={tfna.id}>
                                                                        <input type="radio" {...register(`areasToCheck[${index}].unfounded`)} value={tfna.id} />
                                                                        {tfna.name}
                                                                    </label>
                                                                    </div>
                                                                ))
                                                            }
                                                        </fieldset>
                                                    </Col>
                                                    <Col xs={12} md={6} lg={3}>
                                                        <label className="fw-bold">Estimated Impl. Date</label>
                                                        <input type="date" {...register(`areasToCheck[${index}].estimatedImplDate`)}/> 
                                                    </Col>
                                                    <Col xs={12} md={6} lg={3}>
                                                        <label className="fw-bold">Actual Impl. Date</label>
                                                        <input type="date" {...register(`areasToCheck[${index}].actualImplDate`)}/> 
                                                    </Col>
                                                    <Col xs={12} md={6} lg={6}>
                                                        <label>State Recommendation</label>
                                                        <textarea rows={3} style={{width: '100%'}} {...register(`areasToCheck[${index}].stateRecommendation`)} />
                                                    </Col>
                                                    <Col xs={12} md={6} lg={6}>
                                                        <label>Correction Plan</label>
                                                        <textarea rows={3} style={{width: '100%'}} {...register(`areasToCheck[${index}].correctionPlan`)}/>
                                                    </Col>
                                                </Row>
                                                </div>
                                            </Col>
                                        ))
                                }
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-4">
                            <Button type="submit" variant={values ? "primary" : 'success'} disabled={mutation.isPending || (values ? !isDirty : false)}>
                                {
                                    mutation.isPending
                                    ?
                                        <Spinner animation='border' size='sm' />
                                    :
                                        values
                                        ?
                                            <>Save Changes</>
                                        :
                                            <>Add Response</>
                                }
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </form>
    )
}

export default IncidentResponseToFollowupNew;